import React from "react";
import  './extras.css'

export function Politic() {
  return (
    <div className="ContainerAll" style={{ userSelect: 'none', WebkitUserSelect: 'none', marginBottom:"3%" }}>
        <div className="boxTitles"> 
            <hgroup className="ContainerUp">
            <h2> Políticas de privacidad </h2>
            <h5>Última actualización: <code> 26 de septiembre de 2026</code></h5>
            </hgroup>
            <p>
              En Coronados del bien, accesible desde nuestra plataforma, la
              privacidad de nuestros visitantes es una de nuestras máximas
              prioridades. Este documento de Política de Privacidad detalla los
              tipos de información que recopilamos, cómo la gestionamos y los
              derechos que te asisten.
              <br/>
              Si tenés dudas o necesitás más información sobre el tratamiento de tus
              datos, podés contactarnos directamente a través de nuestro correo
              electrónico de soporte.
            </p>
      </div>
      <div className="boxP">
        <h4>1. Responsable del Tratamiento de los Datos</h4>
        <p>
          El responsable legal del tratamiento de los datos recolectados en este
          sitio web es:
        </p>
        <p>Nombre / Razón Social: Coronados del bien </p>
        <p>Contacto: Droommk12@gmail.com</p>
      </div>
      <div className="boxP">
        <h4>2. Datos que Recopilamos y Tecnología de Terceros</h4>
        <p>
          A través de la navegación en nuestro sitio, recopilamos información de
          forma automatizada mediante tecnologías de análisis:
        </p>
        <ol>
          <li>
             Datos de navegación y analítica: Direcciones IP (anonimizadas),
            tipo de navegador, sistema operativo, páginas de entrada/salida,
            tiempo de permanencia e interacciones dentro del sitio.
          </li>
          <li>
             Cookies: Este sitio utiliza cookies para identificar el
            comportamiento del usuario y mejorar la experiencia de navegación.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>3. Uso de Google Analytics</h4>
        <p>
          Utilizamos Google Analytics, un servicio de análisis web prestado por
          Google, Inc. Google Analytics utiliza "cookies" (archivos de texto
          ubicados en tu dispositivo) para ayudarnos a analizar cómo los
          usuarios interactúan con el sitio.
        </p>
        <p>
          La información generada por la cookie acerca de tu uso del sitio web
          será directamente transmitida y archivada por Google en sus
          servidores. Esta información se procesa de forma agregada y
          estadística con la única finalidad de analizar el rendimiento de
          Coronados del bien y optimizar nuestros contenidos. Podés inhabilitar
          el uso de estas cookies configurando las preferencias de tu navegador
          o utilizando el Complemento de inhabilitación para navegadores de
          Google Analytics.
        </p>
      </div>
      <div className="boxP">
        <h4>4. Visibilidad en Motores de Búsqueda (Search)</h4>
        <p>
          Te informamos que Coronados del bien está indexado y presente en todos
          los principales buscadores de Internet (como Google, Bing, Yahoo,
          entre otros). Esto significa que las páginas públicas del sitio,
          listados o contenidos abiertos pueden ser rastreados por los robots de
          estos motores de búsqueda y aparecer en los resultados de consulta de
          cualquier usuario en la red. Los buscadores operan bajo sus propias
          políticas de privacidad y almacenamiento de caché.
        </p>
      </div>
      <div className="boxP">
        <h4>5. Finalidad del Tratamiento de los Datos</h4>
        <p>
          La recolección de datos técnicos y estadísticos tiene como único
          objetivo
        </p>
        <ol>
          <li>
             Comprender el uso general de la plataforma para implementar
            mejoras técnicas y de diseño.
          </li>
          <li>
             Monitorear el correcto funcionamiento de la web y prevenir
            incidentes de seguridad.
          </li>
          <li>
             Evaluar el impacto de los contenidos indexados en los buscadores.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>6. Base Jurídica para el Tratamiento</h4>
        <p>Tratamos tu información técnica basándonos en:</p>
        <ol>
          <li>
            Tu consentimiento: Al aceptar el banner de cookies y continuar
            navegando en nuestra web.
          </li>
          <li>
            Nuestro interés legítimo: Para garantizar la seguridad del sitio
            web, optimizar el rendimiento técnico y asegurar que la plataforma
            sea funcional para la comunidad.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>7. Retención y Destinatarios de los Datos</h4>
        <ol>
          <li>
            Retención: Los datos de navegación gestionados por Google Analytics
            se almacenan de acuerdo con los plazos estándar de retención de
            dicha plataforma (generalmente 14 meses), tras lo cual se eliminan o
            anonimizan automáticamente.
          </li>
          <li>
             Destinatarios: No vendemos ni compartimos datos con terceros para
            fines comerciales. Los datos analíticos son procesados de manera
            segura por Google bajo los marcos de transferencia internacional de
            datos validados por normativas de privacidad vigentes.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>8. Tus Derechos de Privacidad</h4>
        <p>
          Como usuario, tenés derecho a controlar el uso de tu información.
          Podés:
        </p>
        <ol>
          <li>
            Configurar tu navegador para bloquear o rechazar todas las cookies.
          </li>
          <li>
            Solicitar la eliminación de registros si en algún momento
            interactuás enviando información directa.
          </li>
          <li>
            Ejercer tus derechos de acceso o rectificación escribiéndonos a
            nuestro correo de contacto.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>9. Actualizaciones de esta Política</h4>
        <p>
          Nos reservamos el derecho de modificar esta Política de Privacidad
          para adaptarla a novedades legislativas o cambios en el funcionamiento
          de nuestra plataforma. Cualquier cambio será publicado de inmediato en
          esta sección.
        </p>
      </div>
    </div>
  );
}
